import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash';
import {batch} from 'react-redux';
import {BETSLIP_TABS, WinRiskType, OddsFormat} from '../common/Foundation';
import BetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import BetslipCommon from '../common/BetslipCommon';
import {openAlert} from './AlertSlice';
import BetServices from '../services/BetServices';
import BetslipAction from '../actions/BetslipAction';
import Constants from '../common/Constants';
import {EVENT} from '../events/listEvents';
import {changeButton} from './SidebarSelectedDataSlice';
import {updateLoadingState, 
    updateStakePerBetState, 
    updateStartCountdownState as updateRBStartCountdownState,
    updateResetCountdownState as updateRBResetCountdownState} from './BetslipSlice';
import {updateHRParlayLeg} from './ParlayBetslipSlice';
import {getGuessTimeZone} from '../common/DateUtils';

const EMPTY_VALUE = ''
const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}
const initialState = {
    selectedBetslipTab: BETSLIP_TABS.SINGLE,
    singleBets: EMPTY_ARRAY,
    totalStake: 0,
    potentialWinnings: 0,
    stakeInputs: EMPTY_OBJECT,
    invalidStake: false,
    isLoading: false,
    isError: false,
    isOpenConfirmationRemove: false,
    limitBets: EMPTY_OBJECT,
    currentOddsFormat: EMPTY_VALUE,
    startCountdown: false,
    resetCountdown: false,
    showAttention: false,
    hrBetslipItemList: EMPTY_ARRAY,
}
export const HRBetslipSlice = createSlice({
    name: 'HRBetslipSlice',
    initialState: initialState,
    reducers: {
        updateHRBetslipItems: (state, {payload}) => {
            state.hrBetslipItemList = payload
        },
        pushNewHRBetslipItem: (state, {payload}) => {
            state.hrBetslipItemList = [...state.hrBetslipItemList.filter(bet => bet.status !== Constants.HR_BET_STATUS.ACCEPTED), payload];
        },
        updateBetslipTabState: (state, {payload}) => {
            state.selectedBetslipTab = payload
        },
        updateSingleBetsState: (state, {payload}) => {
            state.singleBets = payload
        },
        pushNewSingBetItem: (state, {payload}) => {
            state.singleBets = [...state.singleBets.filter(bet => bet.status !== Constants.HR_BET_STATUS.ACCEPTED), payload];
        },
        updateHRBetslipItem: (state, {payload}) => {
            if (payload) {
                const {
                    oddsId,
                    oldDisplayOdds,
                    oddsDisplay,
                    odds,
                    status,
                    betSlipEmit,
                    isLimitLoaded
                } = payload;
                for (const bet of state.singleBets) {
                    if (oddsId === bet.oddsId) {
                      if(oldDisplayOdds) {
                        bet.oldDisplayOdds = oldDisplayOdds;
                      }
                      bet.oddsDisplay = oddsDisplay;
                      bet.odds = odds;
                      if(status) {
                        bet.status = status;
                      }
                      bet.isLimitLoaded = isLimitLoaded
                      bet.betSlipEmit = betSlipEmit;
                    }
                }
                for (const bet of state.hrBetslipItemList) {
                    if (oddsId === bet.oddsId) {
                        if(oldDisplayOdds) {
                          bet.oldDisplayOdds = oldDisplayOdds;
                        }
                        bet.oddsDisplay = oddsDisplay;
                        bet.odds = odds;
                        if(status) {
                          bet.status = status;
                        }
                        bet.isLimitLoaded = isLimitLoaded
                        bet.betSlipEmit = betSlipEmit;
                    }
                }
            }
        },
        clearPriceChangedStatusSingleBets: (state, {payload}) => {
            for (const bet of state.singleBets) {
                bet.status = null;
            }
            for (const bet of state.hrBetslipItemList) {
                bet.status = null;
            }
        },
        updateTotalStakeState: (state, {payload}) => {
            state.totalStake = payload
        },
        updatePotentialWinningsState: (state, {payload}) => {
            state.potentialWinnings = payload
        },
        updateHRStakeInputsState: (state, {payload}) => {
            state.stakeInputs = payload
            BetslipHelper.cacheObjectInLocalStorage(payload, 'stakeInputs')
        },
        updateHRStake: (state, {payload}) => {
            const {oddsId} = payload;
            state.stakeInputs[oddsId] = payload;
        },
        updateInvalidStake: (state, {payload}) => {
            state.invalidStake = payload
        },
        updateLoadingState: (state, {payload}) => {
            state.isLoading = payload
        },
        
        updateErrorState: (state, {payload}) => {
            state.isError = payload
        },
        updateConfirmationRemoveState: (state, {payload}) => {
            state.isOpenConfirmationRemove = payload
        },
        updateCurrentOddsFormatState: (state, {payload}) => {
            state.currentOddsFormat = payload
        },
        initTeaserBettingRulesState: (state, {payload}) => {
            state.teaserBettingRules = payload
        },
        updateStartCountdownState: (state, {payload}) => {
            state.startCountdown = payload
        },
        updateResetCountdownState: (state, {payload}) => {
            state.resetCountdown = payload
        },
        updateShowAttentionState: (state, {payload}) => {
            state.showAttention = payload
        },
        updatePlaceSingleBetsSuccessState: state => {
            state.singleBets = []
            state.stakeInputs = {}
        },
        updateLimitBets: (state, {payload}) => {
            state.limitBets = payload;
        }
    },
})

export const {
    updateHRBetslipItems,
    pushNewHRBetslipItem,
    updateBetslipTabState,
    updateSingleBetsState,
    pushNewSingBetItem,
    updateHRBetslipItem,
    clearPriceChangedStatusSingleBets,
    updateTotalStakeState,
    updatePotentialWinningsState,
    updateHRStakeInputsState,
    updateHRStake,
    updateInvalidStake,
    updateCurrentOddsFormatState,
    updateStartCountdownState,
    updateResetCountdownState,
    updateConfirmationRemoveState,
    updateLimitBets,
} = HRBetslipSlice.actions

export default HRBetslipSlice.reducer;

export const checkInvalidStake = () => {
    return (dispatch, getState) => {
        const {singleBets, stakeInputs} = getState().HRBetslipSlice
        let disable = false;
        if (!_.isEmpty(stakeInputs)) {
            singleBets.forEach(bet => {
                if (stakeInputs[bet.oddsId]) {
                    const stake = BetslipCommon.convertStakeToNumber(BetslipHelper.getStake(stakeInputs, bet.oddsId))
                    if (!stake || stake === 0) {
                        disable = true;
                    }
                }
            })
        }
        dispatch(updateInvalidStake(disable))
    }
}

export const updatePlaceHRBetInfo = () => {
    return (dispatch, getState) => {
        const {stakeInputs} = getState().HRBetslipSlice
        batch(() => {
            dispatch(updateTotalStakeState(BetslipHelper.calculateTotalStake(stakeInputs)))
            dispatch(updatePotentialWinningsState(BetslipHelper.calculatePotentialWinnings(stakeInputs)))
        })
    }
}

export const executeHRPlaceSingleBets = () => {
    return async (dispatch, getState) => {
        const {
            singleBets,
        } = getState().HRBetslipSlice;
        let stakeInputs = JSON.parse(JSON.stringify(getState().HRBetslipSlice.stakeInputs));
        const {
            acceptBetterOdds,
        } = getState().BetslipSlice
        const {oddsFormat} = getState().SportsSlice.options
        const payload = BetslipHelper.buildHRPayloadPlaceSingleBets(singleBets.filter(bet => bet.status !== Constants.HR_BET_STATUS.ACCEPTED), stakeInputs, oddsFormat, acceptBetterOdds)
        if (_.isEmpty(payload)) {
            return;
        }
        let res = null;
        try {
            dispatch(updateLoadingState(true));
            dispatch(clearPriceChangedStatusSingleBets());
            try {
                const token = localStorage.getItem('token-user');
                res = await BetslipAction.submitHorseRacingPlaceBets(payload, token, window.env.enableRacebookDomainConfig, window.env.racebookDomain).then(res => {
                    dispatch(updateLoadingState(false));
                    return res
                });
            } catch (e) {
                dispatch(openAlert({
                    message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
                }));
                dispatch(updateLoadingState(false));
                return
            }
            if (!res) {
                dispatch(openAlert({
                    message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
                }));
                dispatch(updateLoadingState(false));
                return
            }
            if (res.status === 200 && res.data) {
              const result = res.data;
              let updatedSingleBets = singleBets;
              let successCount = 0;
              result && result.forEach(item => {
              const {bets, betConfirmStatus, message, errorCode} = item;
              if (betConfirmStatus === 'FAIL') {
                if(errorCode === Constants.HR_BET_STATUS.INVALID_SELECTION) {
                  const matchingBets = [...singleBets];
                  updatedSingleBets = matchingBets.map(bet => ({
                    ...bet,
                    status: Constants.HR_BET_STATUS.INVALID_SELECTION,
                  }))
                  
                } else {
                  const tmp = {
                    message: 'errors:' + message,
                }
                dispatch(openAlert(tmp))
                }
              }

                bets && bets.forEach(bet => {
                  const { reason, winAmount, riskAmount, betId, updatedPrices, ext, status, limit } = bet;
                  const betIndex = singleBets.findIndex(item => {
                    const resOddsId = BetslipHelper.buildHROddsId(bet);
                    return item.oddsId === resOddsId;
                  });

                  if (betIndex >= 0) {
                    const matchingBet = singleBets[betIndex];
                    const placedBet = {
                      ...matchingBet,
                      status,
                      reason,
                      betId,
                      winAmount,
                      riskAmount,
                      updatedPrices,
                      limit
                    };
                    switch (status) {
                      case Constants.HR_BET_STATUS.REJECTED:
                        if (reason === Constants.HR_BET_REASON.PRICE_CHANGED) {
                          const newOdds = Number(updatedPrices[Object.keys(updatedPrices)[0]]['odds']);
                          const newUserOdds = Number(updatedPrices[Object.keys(updatedPrices)[0]]['userOdds']);
                          placedBet.status = Constants.HR_BET_STATUS.PRICE_CHANGED;
                          const oddsIdStake = BetslipHelper.buildHROddsId(bet);
                          placedBet.oldDisplayOdds = matchingBet.oddsDisplay;
                          placedBet.oddsDisplay = newUserOdds;
                          placedBet.odds = newOdds;
                          const matchingStake = stakeInputs[oddsIdStake];
                          let updatedStake = {};
                          if (matchingStake && matchingStake.riskVal && matchingStake.winRiskOption === WinRiskType.RISK) {
                            const riskVal = stakeInputs[oddsIdStake].riskVal ? BetslipCommon.convertStakeToNumber(stakeInputs[oddsIdStake].riskVal) : '';
                            const updatedWinVal = BetslipCommon.calculateToWin(riskVal, newOdds, OddsFormat.Decimal, WinRiskType.RISK, null);
                            updatedStake = { ...matchingStake, odds: newOdds, winVal: updatedWinVal, userOdds: newUserOdds };
                          } else if (matchingStake && matchingStake.winVal && matchingStake.winRiskOption === WinRiskType.WIN) {
                            const winVal = BetslipCommon.convertStakeToNumber(stakeInputs[oddsIdStake].winVal);
                            const updatedRiskVal = BetslipCommon.calculateToRisk(winVal, newOdds, OddsFormat.Decimal, WinRiskType.WIN);
                            updatedStake = { ...matchingStake, odds: newOdds, riskVal: updatedRiskVal, userOdds: newUserOdds };
                          }
                          if (Object.keys(updatedStake).length > 0) {
                            dispatch(updateHRStake(updatedStake));
                          }
                        } else if (ext) {
                          let message = `errors:${ext.errorMessage && ext.errorMessage !== 'PROCESSED_WITH_ERROR' ? ext.errorMessage : ext.errorCode}`;
                          let params;
                          if (ext.errorCode === Constants.BET_ERROR_CODE.BETTING_BUDGET_EXCEEDED) {
                            message = `errors:${ext.errorCode}`;
                            params = [`${ext.errorMessage}`]
                          }
                          const tmp = {
                            message,
                            params,
                          }
                          dispatch(openAlert(tmp))
                        } else {
                          placedBet.status = status;
                          placedBet.reason = (reason === Constants.HR_BET_REASON.EVENT_CLOSED ? Constants.UNAVAILABLE_MESSAGE : reason);
                        }
                        break;
                      case Constants.HR_BET_STATUS.ACCEPTED:
                        successCount++;
                        const { [matchingBet.oddsId]: __, ...updatedStakeInputs } = stakeInputs;
                        batch(() => {
                          stakeInputs = updatedStakeInputs;
                          dispatch(updateHRStakeInputsState(updatedStakeInputs));
                          dispatch(updatePlaceHRBetInfo());
                        });
                        postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, EMPTY_ARRAY);
                        placedBet.externalBetId = ext.externalBetId;
                        break;
                      case Constants.HR_BET_STATUS.PARTIAL:
                        break;
                      case Constants.HR_BET_STATUS.INVALID_SELECTION:
                        break;
                      default:
                        break;
                    }
                    updatedSingleBets = updatedSingleBets.map(updatedBet => updatedBet.oddsId === placedBet.oddsId ? placedBet : updatedBet);
                  }
                });

              });
              if (successCount === singleBets.length) {
                postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, EMPTY_ARRAY);
                dispatch(updateHRStakeInputsState(EMPTY_OBJECT));
                dispatch(updateStakePerBetState(EMPTY_VALUE));
                dispatch(updateHRBetslipItems(EMPTY_ARRAY));
              } else {
                dispatch(updateHRBetslipItems(updatedSingleBets));
                postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, updatedSingleBets.filter(item => item.status !== Constants.HR_BET_STATUS.ACCEPTED).map(item => item.betSlipEmit));
              }
              dispatch(updateSingleBetsState(updatedSingleBets));
              dispatch(updateCurrentOddsFormatState(oddsFormat))
              reloadBalanceAndPendingBets();
            } else {
                dispatch(openAlert({
                    message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
                }))
            }
        } catch (error) {
          console.log(error)
            dispatch(updateLoadingState(false))
        }
    }
}

export const reloadBalanceAndPendingBets = () => {
  window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD)
  window.fireEvent(EVENT.FETCH_PENDING_BETS)
}

export const postMessageToHRIframe = (msgCode, msgData) => {
    const HRIframe = document.querySelector('iframe#horse_racing_iframe');
    const payload = {
        msgCode,
        msgData
    }
    HRIframe && HRIframe.contentWindow.postMessage(payload, '*');
}

export const removeSingleBetItem = (id) => {
    return async (dispatch, getState) => {
        const singleBets = getState().BetslipSlice.singleBets;
        const hrSingleBets = getState().HRBetslipSlice.singleBets;
        const {options} = getState().SportsSlice
        if (hrSingleBets.length + singleBets.length === 1) {
            batch(() => {
                dispatch(updateSingleBetsState(EMPTY_ARRAY));
                dispatch(updateHRBetslipItems(EMPTY_ARRAY));
                dispatch(updateHRStakeInputsState(EMPTY_OBJECT))
                dispatch(updateTotalStakeState(0));
                dispatch(updatePotentialWinningsState(0));
                dispatch(updateConfirmationRemoveState(false))
                dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
            })
            postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, EMPTY_ARRAY);
        } else {
            const bets = hrSingleBets.filter((bet) => {
                return bet.oddsId !== id
            })
            postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, bets.map(item => item.status !== Constants.HR_BET_STATUS.ACCEPTED ? item.betSlipEmit : undefined));
            batch(() => {
                dispatch(updateSingleBetsState(bets));
                dispatch(updateHRBetslipItems(bets));
                const stakeInputs = {...getState().HRBetslipSlice.stakeInputs};
                if (stakeInputs[id]) {
                    delete stakeInputs[id]
                    dispatch(updateHRStakeInputsState(stakeInputs))
                    dispatch(updatePlaceHRBetInfo())
                }
            })
        }
    }
}

export const changeStakeInputs = (inputs) => {
    return (dispatch, getState) => {
        const stakeInputs = {...getState().HRBetslipSlice.stakeInputs};
        stakeInputs[inputs.oddsId] = inputs
        dispatch(updateHRStakeInputsState(stakeInputs))
    }
}

export const removeAllHRSingleBets = () => {
    return (dispatch, getState) => {
        const {options} = getState().SportsSlice;
        batch(() => {
            dispatch(updateSingleBetsState(EMPTY_ARRAY));
            dispatch(updateHRBetslipItems(EMPTY_ARRAY));
            dispatch(updateHRStakeInputsState(EMPTY_OBJECT))
            dispatch(updateConfirmationRemoveState(false))
            dispatch(updateRBResetCountdownState(false))
            dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
        })
        postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, EMPTY_ARRAY);
    }
}

export const getHRLimitBet = (isRefresh) => (dispatch, getState) => {
    const singleBets = JSON.parse(JSON.stringify(getState().HRBetslipSlice.singleBets));
    const oddsFormat = getState().SportsSlice.options.oddsFormat;
    const timeZoneId = getState().SportsSlice.options.timeZoneId || getGuessTimeZone();
    const betsToGetLimit = BetslipHelper.buildGetLimitPayload(singleBets, oddsFormat, timeZoneId);
    let betsToGetLimitMap = {};
    betsToGetLimit.forEach(element => {
        betsToGetLimitMap[element.uniqueRequestId] = element;
    });
    if (betsToGetLimit.length === 0) return;
    const stakeInputs = getState().HRBetslipSlice.stakeInputs;
    isRefresh && dispatch(updateLoadingState(true));
    BetServices.getLimitBet(betsToGetLimit).then(res => {
        const result = res.data;
        if (res.status !== 200 || (!result && !result.status && result.state !== 200)) return;
        const limitBet = {};
        let isFailure = false;
        result.forEach((limitData) => {
            const {id, minRisk, minWin, maxRisk, maxWin, latestOdds, message} = limitData;
            if (id) {
                const betType = _.get(betsToGetLimitMap[id], 'legs[0].betType', []);
                const matchBet = betsToGetLimit && betsToGetLimit.find(bet => {
                  if(latestOdds && latestOdds[0]) {
                    const {raceNumber, meetingId, runnerNumber} = latestOdds[0];
                    const tmpLimit = {raceNumber, meetingId, runnerNumber, betType}
                    const limitId = BetslipHelper.buildHROddsId(tmpLimit);
                    const betId = BetslipHelper.buildHROddsId(bet.legs[0]);
                    return betId === limitId;
                  }
                });
                if (matchBet) {
                    const oddsId = BetslipHelper.buildHROddsId(matchBet.legs[0]);
                    limitBet[oddsId] = {minRisk, minWin, maxRisk, maxWin};
                } else {
                    isFailure = true;
                }
                singleBets.forEach((bet) => {
                    const {oddsId, raceNumber, meetingId, runnerNumber} = bet;
                    const matchBet = latestOdds && latestOdds.find((item) =>
                        `${raceNumber}-${meetingId}-${runnerNumber}-${bet.betType}` === `${item.raceNumber}-${item.meetingId}-${item.runnerNumber}-${betType}`
                    )
                    if (matchBet) {
                        const price = matchBet.price;
                        const newUserOdds = Number(price[betType.toLowerCase()]);
                        const newOdds = Number(price[`${betType.toLowerCase()}Decimal`]);
                        if (newUserOdds) {
                            const matchingStake = stakeInputs[oddsId];
                            let updatedStake = {};
                            if (matchingStake && matchingStake.riskVal && matchingStake.winRiskOption === WinRiskType.RISK) {
                                const riskVal = stakeInputs[oddsId].riskVal ? BetslipCommon.convertStakeToNumber(stakeInputs[oddsId].riskVal) : '';
                                const updatedWinVal = BetslipCommon.calculateToWin(riskVal, newOdds, OddsFormat.Decimal, WinRiskType.RISK, null);
                                updatedStake = {...matchingStake, odds: newOdds, winVal: updatedWinVal, userOdds: newUserOdds};
                            } else if (matchingStake && matchingStake.winVal && matchingStake.winRiskOption === WinRiskType.WIN) {
                                const winVal = BetslipCommon.convertStakeToNumber(stakeInputs[oddsId].winVal);
                                const updatedRiskVal = BetslipCommon.calculateToRisk(winVal, newOdds, OddsFormat.Decimal, WinRiskType.WIN);
                                updatedStake = {...matchingStake, odds: newOdds, riskVal: updatedRiskVal, userOdds: newUserOdds};
                            }
                            if (Object.keys(updatedStake).length > 0) {
                                dispatch(updateHRStake(updatedStake));
                            }
                            if (newUserOdds && bet.odds !== newOdds && !bet.status) {
                                bet.status = Constants.HR_BET_STATUS.PRICE_CHANGED;
                                bet.oldDisplayOdds = Number(bet.oddsDisplay);
                            }
                            bet.oddsDisplay = newUserOdds;
                            bet.odds = newOdds;
                            bet.isLimitLoaded = true;
                            bet.betSlipEmit = {...bet.betSlipEmit, odds: newOdds, userOdds: newUserOdds};
                            dispatch(updateHRBetslipItem(bet));
                            dispatch(updateHRParlayLeg(bet));
                            dispatch(updateRBStartCountdownState(true))
                            dispatch(updateRBResetCountdownState(true))
                        }
                    }
                })
            } else {
                isFailure = true;
                dispatch(openAlert({
                    message: message || 'errors|' + Constants.BET_ERROR_CODE.INTERNAL_ERROR,
                    params: [{nsSeparator: '|'}],
                }))
            }
        });
        !isFailure && batch(() => {
            dispatch(updatePlaceHRBetInfo());
            dispatch(updateLimitBets(limitBet));
            if (singleBets.length === 0) {
                dispatch(updateHRStakeInputsState(EMPTY_OBJECT));
            }
        });
        
        isRefresh && dispatch(updateLoadingState(false));
    });
}

export const updateAllHRStake = (stake, winRiskOption) => {
    return (dispatch, getState) => {
        const {oddsFormat} = getState().SportsSlice.options
        const {singleBets,} = getState().HRBetslipSlice;
        const stakeInputs = JSON.parse(JSON.stringify(getState().HRBetslipSlice.stakeInputs));
        if (_.isEmpty(stakeInputs) || singleBets.length !== Object.keys(stakeInputs).length) {
            singleBets.forEach(({oddsId, odds}) => {
                stakeInputs[oddsId] = {odds, oddsId}
            });
        }
        Object.keys(stakeInputs).forEach(key => {
            const inputs = {}
            let winRiskStake = winRiskOption;
            if (!winRiskStake) {
                winRiskStake = BetslipHelper.getWinRiskOptionByOdds(stakeInputs[key].userOdds)
            }
            if (winRiskStake === WinRiskType.RISK) {
                inputs.riskVal = stake ? BetslipCommon.convertStakeToNumber(stake) : '';
                inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.riskVal, stakeInputs[key].odds, OddsFormat.Decimal, winRiskStake, stakeInputs[key].betType) : ''
            } else if (winRiskStake === WinRiskType.WIN) {
                inputs.winVal = stake ? BetslipCommon.convertStakeToNumber(stake) : '';
                inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.winVal, stakeInputs[key].odds, OddsFormat.Decimal, winRiskStake) : ''
            } else if (winRiskStake === WinRiskType.BASE) {
                inputs.winVal = stake ? BetslipCommon.calculateToWin(inputs.baseVal, stakeInputs[key].odds, OddsFormat.Decimal, winRiskStake, stakeInputs[key].betType) : '';
                inputs.riskVal = stake ? BetslipCommon.calculateToRisk(inputs.baseVal, stakeInputs[key].odds, OddsFormat.Decimal, winRiskStake) : '';
            }
            stakeInputs[key].winRiskOption = winRiskStake;
            stakeInputs[key].riskVal = inputs.riskVal;
            stakeInputs[key].winVal = inputs.winVal;
        })
        batch(() => {
            dispatch(updateHRStakeInputsState(stakeInputs))
        })

    }
}


// WEBPACK FOOTER //
// ./src/app/slices/HRBetslipSlice.js